import type { ComponentType, ReactNode } from "react";
import I18n from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

export interface ItemProps {
  addon?: ReactNode;
  childClassName?: string;
  children: ReactNode;
  className?: string;
  LabelComponent?: ComponentType<{ weight?: string }>;
  name: string;
  optional?: boolean;
}

export const Item = ({
  name,
  addon,
  className,
  childClassName,
  children,
  optional,
  LabelComponent = Typography.LabelSm,
}: ItemProps) => (
  <div className={classNames(className, "flex flex-col")}>
    <div
      className={classNames(childClassName, "mb-1 flex flex-row items-center")}
    >
      <div className="flex flex-row items-center gap-x-1">
        <LabelComponent weight="semibold">
          {I18n.t(`paywall_checkout.form.fields.${name}`)}
        </LabelComponent>
        {optional && (
          <>
            {" "}
            <Typography.LabelSm weight="normal" color="text-light">
              {`(${I18n.t("paywall_checkout.form.fields.optional")})`}
            </Typography.LabelSm>
          </>
        )}
      </div>
      {addon}
    </div>
    {children}
  </div>
);
